import React, { useState } from "react";
import copy from "copy-to-clipboard";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Clipboard, ClipboardCheck } from "react-bootstrap-icons";

// This component is rendered to display email data in Ag-Grid.
// The returned view includes a "copy to clipboard" icon.
// A user can readily copy the email to clipboard by clicking on the clipboard icon.
function EmailFormatter(props) {
  const { value } = props;
  const [copied, setCopied] = useState(false);

  const handleClipboardClick = (_event) => {
    copy(value);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };
  return (
    <>
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip>{copied ? "Copied!" : "Click to copy!"}</Tooltip>}
      >
        {copied ? (
          <ClipboardCheck />
        ) : (
          <Clipboard
            onClick={handleClipboardClick}
            style={{ cursor: "pointer" }}
          />
        )}
      </OverlayTrigger>{" "}
      {value}
    </>
  );
}

export default EmailFormatter;
